document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.header__carousel');

    // const images = slider.querySelectorAll('.carousel-cell img');
    // let imagesLoaded = 0;

    // images.forEach(img => {
    //     img.addEventListener('load', () => {
    //         console.log('image loaded');

    //         imagesLoaded += 1;
    //         if (imagesLoaded === images.length) {
    //             console.log('All images loaded');
    //             initializeFlickity( slider );
    //         }
    //     });
    // });


    if (slider) {
        initializeFlickity(slider);
    }

    function initializeFlickity(elem) {
        const Flickity = require('flickity');

        const isAutomatic = elem.classList.contains('slider_automatic');

        const flkty = new Flickity(elem, {
            contain: true,
            draggable: true,
            pageDots: isAutomatic ? false : true,
            prevNextButtons: isAutomatic ? false : true,
            autoPlay: isAutomatic ? 3000 : false,
            imagesLoaded: true,
            pauseAutoPlayOnHover: false
        });
    }
});